import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelize } from 'src/utils/decamelize';

import { Terminal } from './_types';

export const normalizeTerminal = (data: any): Terminal => {
  return camelcaseKeys(data, { deep: true });
};

export const denormalizeTerminal = (terminal: Partial<Terminal>): any => {
   
  const { id, ...terminalWithoutId } = terminal;
  return Object.keys(terminalWithoutId).reduce((acc, key) => {
    acc[decamelize(key)] =
      terminalWithoutId[key as keyof typeof terminalWithoutId];
    return acc;
  }, {} as Record<string, any>);
};
